import {
  configApiRef,
  errorApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import {
  createScaffolderFormDecorator,
  FormDecoratorBlueprint,
  type ScaffolderFormDecorator,
} from '@backstage/plugin-scaffolder-react/alpha';
import { getTessaUserAssertion } from '@ns/plugin-ns-tessa-common';

const TESSA_ASSERTION_SECRET = 'tessaApiAssertion';

const tessaOboAssertion = createScaffolderFormDecorator({
  async decorator({ setSecrets }, { configApi, errorApi, microsoftAuthApi }) {
    try {
      const assertion =
        (await getTessaUserAssertion({ configApi, microsoftAuthApi })) ??
        'dummy-assertion';
      setSecrets(current => ({
        ...current,
        [TESSA_ASSERTION_SECRET]: assertion,
      }));
    } catch (error) {
      errorApi.post(
        new Error('Could not sign you in for Tessa. Try again.', {
          cause: error,
        }),
      );
      throw error;
    }
  },
  deps: {
    configApi: configApiRef,
    errorApi: errorApiRef,
    microsoftAuthApi: microsoftAuthApiRef,
  },
  id: 'tessa:obo-assertion',
});

export const tessaOboAssertionDecorator: ExtensionDefinition<{
  kind: 'scaffolder-form-decorator';
  name: 'tessa-obo-assertion';
  params: { decorator: ScaffolderFormDecorator };
}> = FormDecoratorBlueprint.make({
  name: 'tessa-obo-assertion',
  params: { decorator: tessaOboAssertion },
});
